// src/utils/auth-token.utils.js

import { encryptData } from '@/utils/crypto'

export const generateBasicToken = (timeStamp) => {
  const username = import.meta.env.VITE_AUTH_USERNAME
  const password = import.meta.env.VITE_AUTH_PASSWORD

  const combined = `${username}:${password}:${timeStamp}`

  return encryptData(combined, '3a956599c7edd8f5526bc681fa0616aa')
}
